import React, { useCallback } from 'react';
import { Badge, Button, Card, Col, Container, Row } from 'react-bootstrap';

import FeedbackForm from '../components/feedback/FeedbackForm';
import { useAuth } from '../context/AuthContext';
import { useFeedback } from '../context/FeedbackContext';

const PRIMARY_COLOR = '#1e305a';
const ACCENT_COLOR = '#66bb33';

const Feedbacks: React.FC = () => {
  const { user } = useAuth();
  const { requestFeedback, isChecking } = useFeedback();
  const normalizedRole = String(user?.role ?? '').trim().toLowerCase();
  const canSeeSidePanel = normalizedRole === 'admin' || normalizedRole === 'analista';

  // O formulario embutido nesta pagina nao precisa fazer nada apos sucesso
  // alem do feedback visual interno do proprio componente.
  const handleSuccess = useCallback(() => {
    /* feedback visual ja exibido pelo proprio FeedbackForm */
  }, []);

  const handleOpenModal = useCallback(() => {
    void requestFeedback({ force: true });
  }, [requestFeedback]);

  return (
    <Container fluid className="py-4">
      <Card className="shadow-sm border-0">
        <Card.Header
          style={{
            backgroundColor: PRIMARY_COLOR,
            color: '#ffffff',
            borderBottom: `4px solid ${ACCENT_COLOR}`,
          }}
        >
          <div className="d-flex align-items-center justify-content-between flex-wrap gap-2">
            <div>
              <h4 className="mb-0">Feedback do Usuário</h4>
              <small className="text-white-50">
                Sua opinião ajuda a melhorar a plataforma SUPORTNECT
              </small>
            </div>
            <Badge bg="light" text="dark" className="px-3 py-2">
              Avalie a qualquer momento
            </Badge>
          </div>
        </Card.Header>

        <Card.Body>
          <Row className="g-4">
            <Col xs={12} lg={canSeeSidePanel ? 7 : 12}>
              <Card className="h-100 border-0 shadow-sm">
                <Card.Body>
                  <h5 style={{ color: PRIMARY_COLOR }} className="mb-3">
                    <i className="bi bi-stars me-2" aria-hidden="true"></i>
                    Deixe seu feedback
                  </h5>
                  <p className="text-muted small mb-4">
                    Escolha a plataforma como um todo, um módulo (Incidentes, Compras, etc.)
                    e depois o menu ou fluxo que deseja avaliar. O comentário é opcional
                    (até 250 caracteres) e você pode enviar de forma anônima.
                  </p>
                  <FeedbackForm
                    initialWorkflowId={null}
                    allowGeneralFeedback
                    allowWorkflowChange
                    onSuccess={handleSuccess}
                  />
                </Card.Body>
              </Card>
            </Col>

            {canSeeSidePanel && (
              <Col xs={12} lg={5}>
                <Card className="h-100 border-0 shadow-sm">
                  <Card.Body>
                    <h6 style={{ color: ACCENT_COLOR }} className="mb-2">
                      <i className="bi bi-info-circle me-2" aria-hidden="true"></i>
                      Como funciona
                    </h6>
                    <ul className="text-muted small ps-3 mb-3">
                      <li>Sua avaliação fica salva e é usada para melhorar continuamente.</li>
                      <li>
                        Quando você marca como <strong>anônimo</strong>, sua identidade
                        fica oculta.
                      </li>
                      <li>
                        A frequência do convite de feedback pode ser configurada por fluxo
                        (área de administração).
                      </li>
                    </ul>
                    <hr />
                    <h6 style={{ color: PRIMARY_COLOR }} className="mb-2">
                      <i className="bi bi-window-stack me-2" aria-hidden="true"></i>
                      Prefere o modal flutuante?
                    </h6>
                    <p className="text-muted small mb-3">
                      Você também pode abrir o mesmo formulário na janela rápida de feedback
                      (botão no canto da tela), disponível em todo o sistema.
                    </p>
                    <Button
                      variant="outline-success"
                      onClick={handleOpenModal}
                      disabled={isChecking}
                    >
                      <i className="bi bi-chat-heart me-2" aria-hidden="true"></i>
                      Abrir modal de feedback
                    </Button>
                  </Card.Body>
                </Card>
              </Col>
            )}
          </Row>
        </Card.Body>
      </Card>
    </Container>
  );
};

export default Feedbacks;
